export type PeopleAudience = 'all' | 'friends' | 'following'
export type PeopleGender = 'any' | 'women' | 'men'
export type PeopleAgeGroup = '18_24' | '25_34' | '35_44' | '45p'
export type PeopleSort = 'trending' | 'newest'

export type PeopleFilters = {
  q?: string
  audience: PeopleAudience
  gender: PeopleGender
  ageGroup: PeopleAgeGroup | null
  sort: PeopleSort
  prosOnly: boolean
  prosToGo: boolean
  nearMe: boolean
  zipcode: string
  radiusMiles: number | null
}

export const DEFAULT_PEOPLE_FILTERS: PeopleFilters = {
  q: '',
  audience: 'all',
  gender: 'any',
  ageGroup: null,
  sort: 'trending',
  prosOnly: false,
  prosToGo: false,
  nearMe: false,
  zipcode: '',
  radiusMiles: null,
}

export function normalizePeopleFilters(input?: Partial<PeopleFilters> | null): PeopleFilters {
  return {
    q: input?.q ?? '',
    audience: input?.audience ?? 'all',
    gender: input?.gender ?? 'any',
    ageGroup: input?.ageGroup ?? null,
    sort: input?.sort ?? 'trending',
    prosOnly: input?.prosOnly ?? false,
    prosToGo: input?.prosToGo ?? false,
    nearMe: input?.nearMe ?? false,
    zipcode: input?.zipcode ?? '',
    radiusMiles: input?.radiusMiles ?? null,
  }
}

export function serializePeopleFilterParams(input?: PeopleFilters | null): {
  audience?: Exclude<PeopleAudience, 'all'>
  gender?: Exclude<PeopleGender, 'any'>
  age_group?: PeopleAgeGroup
  sort?: PeopleSort
  pros_only?: 1
  pros_to_go?: 1
  near_me?: 1
  zipcode?: string
  radius_miles?: number
} {
  const f = normalizePeopleFilters(input ?? undefined)
  const out: any = {}
  if (f.audience !== 'all') out.audience = f.audience
  if (f.gender !== 'any') out.gender = f.gender
  if (f.ageGroup) out.age_group = f.ageGroup
  if (f.sort) out.sort = f.sort
  if (f.prosOnly) out.pros_only = 1
  if (f.prosToGo) out.pros_to_go = 1
  if (f.nearMe) out.near_me = 1
  if (f.zipcode.trim()) out.zipcode = f.zipcode.trim()
  if (f.radiusMiles && f.radiusMiles > 0) out.radius_miles = f.radiusMiles
  return out
}

export function isDefaultPeopleFilters(input?: PeopleFilters | null): boolean {
  const f = normalizePeopleFilters(input ?? undefined)
  return (
    f.audience === 'all' &&
    f.gender === 'any' &&
    !f.ageGroup &&
    f.sort === 'trending' &&
    !f.prosOnly &&
    !f.prosToGo &&
    !f.nearMe &&
    !f.zipcode.trim() &&
    !f.radiusMiles &&
    !(f.q && f.q.trim())
  )
}
